import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { PenLine, LogOut, Home, Plus } from "lucide-react";

export default function Shell({ children, right, back }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen flex flex-col">
      <header className="hair-b px-6 lg:px-10 py-4 flex items-center justify-between sticky top-0 z-10" style={{ background: "var(--paper)" }}>
        <div className="flex items-center gap-6">
          <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
            <PenLine className="w-5 h-5" style={{ color: "var(--primary)" }} />
            <span className="font-serif-display text-2xl tracking-tight">Scriptora</span>
          </Link>
          <nav className="hidden md:flex items-center gap-4">
            <Link to="/" className="mono-label hover:text-black transition-colors flex items-center gap-1.5" data-testid="nav-home">
              <Home className="w-3 h-3" /> Home
            </Link>
            {back && (
              <button
                onClick={() => nav(back.to)}
                className="mono-label hover:text-black transition-colors"
                data-testid="nav-back"
              >
                ← {back.label}
              </button>
            )}
          </nav>
        </div>
        <div className="flex items-center gap-3">
          {right}
          <span className="mono-label hidden sm:inline" data-testid="user-name">{user?.name}</span>
          <button
            data-testid="logout-button"
            onClick={logout}
            className="btn-ghost flex items-center gap-2 text-sm px-3 py-2 rounded-md"
          >
            <LogOut className="w-4 h-4" /> Sign out
          </button>
        </div>
      </header>
      <main className="flex-1 px-6 lg:px-10 py-8 lg:py-12">{children}</main>
    </div>
  );
}

export function PrimaryLinkButton({ to, testid, children }) {
  return (
    <Link
      to={to}
      data-testid={testid}
      className="btn-primary inline-flex items-center gap-2 text-sm px-4 py-2 rounded-md"
    >
      <Plus className="w-4 h-4" /> {children}
    </Link>
  );
}
